import { c as _c } from "react/compiler-runtime";
import Image, { ImageLoader, ImageProps, StaticImageData } from 'next/image';
import { ReactElement, memo } from 'react';
import { ImageMimeTypes } from '@spa/lib/cms/const';
import useImagesLoader from '@spa/lib/react/hooks/useImagesLoader';
export interface StaticRequire {
  default: StaticImageData;
}
export type ImageComponentProps = ImageProps & {
  readonly mimeType?: string;
};
export type StaticImport = StaticRequire | StaticImageData;
const supportedImageTypes: ReadonlyArray<string> = ['jpg', 'jpeg', 'png', 'webp', 'avif'];
const isSupportedImageType = (href: string): boolean => {
  const pathname: string = new URL(href, 'http://localhost').pathname.toLowerCase();
  const imageTypeRegexPattern: string = String.raw`^.+\.(${supportedImageTypes.join('|')})(\?.*)?$`;
  const imageTypeRegex: RegExp = new RegExp(imageTypeRegexPattern, 'i');
  return imageTypeRegex.test(pathname);
};
const isSupportedMimeType = (mimeType: string): boolean => {
  switch (mimeType) {
    case ImageMimeTypes.JPEG:
    case ImageMimeTypes.PNG:
    case ImageMimeTypes.WEBP:
    case ImageMimeTypes.AVIF:
      return true;
    default:
      return false;
  }
};
function isStaticImageData(src: StaticImport): src is StaticImageData {
  return typeof src === 'object' && src !== null && 'src' in src;
}
function toSrcString(src: string | StaticImport): string {
  let srcString: string;
  if (typeof src === 'string') {
    srcString = src;
  } else if (isStaticImageData(src)) {
    srcString = src.src;
  } else {
    srcString = src.default.src;
  }
  return srcString;
}
function ImageComponent(props) {
  const $ = _c(10);
  const {
    src,
    unoptimized,
    mimeType
  } = props;
  let isSupportedType;
  if (mimeType) {
    let t0;
    if ($[0] !== mimeType) {
      t0 = isSupportedMimeType(mimeType);
      $[0] = mimeType;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    isSupportedType = t0;
  } else {
    let t0;
    if ($[2] !== src) {
      t0 = isSupportedImageType(toSrcString(src));
      $[2] = src;
      $[3] = t0;
    } else {
      t0 = $[3];
    }
    isSupportedType = t0;
  }
  const imagesLoader = useImagesLoader();
  let imageProps;
  if ($[4] !== props) {
    imageProps = {
      ...props
    };
    delete imageProps.mimeType;
    $[4] = props;
    $[5] = imageProps;
  } else {
    imageProps = $[5];
  }
  const t0 = isSupportedType ? imagesLoader : undefined;
  const t1 = unoptimized ?? !isSupportedType;
  let t2;
  if ($[6] !== imageProps || $[7] !== t0 || $[8] !== t1) {
    t2 = <Image {...imageProps} loader={t0} unoptimized={t1} />;
    $[6] = imageProps;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
export default memo(ImageComponent);